import { CommonModule, ViewportScroller, Location } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';

import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { TrackingComponent } from 'src/app/shared/components/tracking/tracking.component';
import { AsideNavbar } from 'src/app/shared/model/request-detail.model';
import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';
import { SharedModule } from 'src/app/shared/shared.module';
import { NavigationService } from 'src/app/core/services/navigation.service';
import i18next from 'i18next';
import { InfoPetitionerComponent } from 'src/app/shared/components/info-petitioner/info-petitioner.component';
import { ApproversComponent } from 'src/app/shared/components/approvers/approvers.component';
import { CarConfiguratorComponent } from 'src/app/shared/components/car-configurator/car-configurator.component';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { Translate } from 'src/app/shared/utils/translate';
import {
  StatusStep,
  StatusStepperComponent
} from 'src/app/shared/components/status-stepper/status-stepper.component';
import { DetailLeasingRequestComponent } from '../../shared/components/detail-leasing-request/detail-leasing-request.component';
import { RequestStatus } from 'src/app/shared/model/requestStatus.enum';

@Component({
  standalone: true,
  selector: 'app-detail-request',
  templateUrl: './detail-request.component.html',
  styleUrls: ['./detail-request.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatStepperModule,
    TrackingComponent,
    InfoPetitionerComponent,
    ApproversComponent,
    CarConfiguratorComponent,
    StatusStepperComponent,
    DetailLeasingRequestComponent
  ]
})
export class DetailRequestComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  user!: User;
  spinner = false;
  requestNumber!: string;
  orderInfo: any;
  isModifyMode = false;
  isDetail = true;
  isProject = false;

  isExceeded = true;
  sectionList: AsideNavbar[] = [];
  requestTypeEnum = RequestType;
  noData = i18next.t('noData');
  controller?: AuthorizerUsers;
  delegatedApprover?: AuthorizerUsers;
  car: any;
  requestStatusEnum = RequestStatus;
  errorDetail = false;
  vehicleShowId: any = null;

  statusSteps: StatusStep[] = [
    { title: i18next.t('pendingApproval') },
    { title: i18next.t('inProcess') },
    { title: i18next.t('inDelivery') },
    { title: i18next.t('delivered') }
  ];
  currentStatusStep = 0;

  constructor(
    public translate: Translate,
    private storageService: StorageService,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private scroller: ViewportScroller,
    private navigationService: NavigationService,
    private location: Location
  ) {}

  ngOnInit(): void {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.route.paramMap.subscribe((params) => {
      this.requestNumber = params.get('requestNumber')!;
    });
    this.route.queryParams.subscribe((queryParams) => {
      this.isModifyMode = queryParams['mode'] === 'modify';
    });
    this.route.queryParams.subscribe((queryParams) => {
      this.isProject = queryParams['type'] === 'PROJECT';
    });
    this.vehicleShowId = this.storageService.get('vehicleShowId');
    if (!this.vehicleShowId) this.vehicleShowId = this.requestNumber;
    this.getDetailRequest(this.requestNumber);
  }

  ngOnDestroy(): void {
    this.storageService.removeItem('vehicleShowId');
  }

  goBack() {
    this.location.back();
  }

  setNavbar() {
    this.sectionList = [
      { name: i18next.t('requestPetitionerTitle'), value: 'petitionerInfo' },
      { name: i18next.t('requestInfo'), value: 'requestData' },
      { name: i18next.t('orderData'), value: 'newCar' },
      { name: i18next.t('deliveredCar'), value: 'deliveredCar' },
      { name: i18next.t('stateTitle'), value: 'status' }
    ];
    if (this.orderInfo?.controller || this.orderInfo?.delegatedApprover) {
      const approvers = { name: 'Aprobadores', value: 'approvers' };
      this.sectionList.splice(1, 0, approvers);
    }
    if (this.orderInfo?.replacedVehicle) {
      const substituCar = {
        name: 'Vehículo a sustituir',
        value: 'substituCar'
      };
      this.sectionList.splice(5, 0, substituCar);
    }
    if (this.orderInfo?.bookingData) {
      const bookingData = {
        name: i18next.t('bookingData'),
        value: 'bookingData'
      };
      this.sectionList.splice(6, 0, bookingData);
    }
  }

  setStatusSteps() {
    /* Status steps */
    if (this.orderInfo.previousRequestStatus) {
      const previousRequestStatus = this.orderInfo.previousRequestStatus;
      for (let index = 0; index < previousRequestStatus.length; index++) {
        const status = previousRequestStatus[index];
        const date = status.date.split('T')[0].split('-').reverse().join('/');
        switch (status.requestStatus) {
          case 'NEW_REQUEST':
          case 'PENDING_APPROVAL':
            if (this.orderInfo.requestType === this.requestTypeEnum.dotArr)
              this.statusSteps[0].title = i18next.t('pendingProcessing');
            else this.statusSteps[0].title = i18next.t('pendingApproval');
            this.statusSteps[0].subtitle = date;
            this.currentStatusStep = 0;
            break;
          case 'SENT_TO_FACTORY':
          case 'IN_PRODUCTION':
          case 'PENDING_REGISTRATION':
          case 'REGISTERED':
          case 'PENDING_ASSIGNMENT':
          case 'PENDING_EXPEDITION':
            this.statusSteps[1].subtitle = date;
            this.currentStatusStep = 1;
            break;
          case 'IN_EXPEDITION':
          case 'IN_EXPEDITION_FACTORY':
          case 'PENDING_PICK_UP':
            this.statusSteps[2].subtitle = date;
            this.currentStatusStep = 2;
            break;
          case 'ACTIVE':
            this.statusSteps[3].subtitle = date;
            this.currentStatusStep = 4;
            break;
          default:
            break;
        }
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('');
    }, 0);
  }

  getDetailRequest(requestNumber: string) {
    this.spinner = true;
    if (this.isProject) {
      this.orderService.getDetailProject(requestNumber).subscribe({
        next: (res) => {
          this.orderInfo = res;
          this.spinner = false;
          this.setNavbar();
          this.setStatusSteps();
        },
        error: () => {
          this.spinner = false;
          this.errorDetail = true;
        }
      });
    } else {
      this.orderService.getDetailRequest(requestNumber).subscribe({
        next: (res) => {
          this.orderInfo = res;
          if (!!this.orderInfo.vehicle) {
            this.car = this.orderInfo.vehicle;
          } else if (!!this.orderInfo.newVehicleDTO) {
            this.car = this.orderInfo.newVehicleDTO;
          }
          this.spinner = false;
          this.setNavbar();
          this.setStatusSteps();
        },
        error: () => {
          this.spinner = false;
          this.errorDetail = true;
        }
      });
    }
  }

  getDetailLoan() {
    this.getDetailRequest(this.requestNumber);
  }

  stepTo(data: string) {
    this.scroller.scrollToAnchor(data);
  }

  onSelectionAuthorizers(event: {
    controller: AuthorizerUsers;
    authorizer: AuthorizerUsers;
  }) {
    this.controller = event.controller;
    this.delegatedApprover = event.authorizer;
  }

  printButton() {
    window.print();
  }

  isCarpool() {
    if (!this.orderInfo) return false;
    if (!this.orderInfo.loanDataDTO || !this.orderInfo.loanDataDTO.loanType)
      return false;
    return (
      this.orderInfo.requestType === 'LOAN' &&
      this.orderInfo.loanDataDTO.loanType === 'CARPOOL'
    );
  }
}
